export default __webpack_public_path__ + "static/meta-image-3destate-f9e66b1158611a94124cabcfe5d45d00.jpg";